import React, { useEffect, useState } from "react";
import axios from "axios";
import WeatherForecastDay from "./WeatherForecastDay";

export default function WeatherForecast(props) {
  let [ready, setReady] = useState(false);
  let [forecast, setForecast] = useState(null);

  useEffect(() => {
    setReady(false);
  }, [props.coordinates]);

  function handleResponse(response) {
    setForecast(response.data.daily);
    setReady(true);
  }
  
  if (ready) {
    return (
      <div className="WeatherForecast">
        <div className="row">
          {forecast.map(function (dailyForecast, index){
            if (index < 5) {
              return(
              <div className="col" key={index}>
                <WeatherForecastDay data={dailyForecast} unit={props.unit} />
              </div>);
            } else {
              return null;
            }
          })}
        </div>
      </div>
     );

  } else {

  let apiKey = `523153ffc9ade9361b141e46da936c85`;
  let longitude = props.coordinates.lon;
  let latitude = props.coordinates.lat;
  let unit = "metric";
  let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${latitude}&lon=${longitude}&appid=${apiKey}&units=${unit}`;
  
  axios.get(apiUrl).then(handleResponse);
  
  return null;
  }
}